import React from 'react';
import classNames from 'classnames';
import { getStatusColor } from '../../utils/theme-utils';

type StatusType = 'danger' | 'warning' | 'success' | 'info' | 'default';

interface Props {
  type?: StatusType;
  children: React.ReactNode;
  className?: string;
  center?: boolean;
}

const TextStatus: React.FC<Props> = ({
  type = 'default',
  children,
  className,
  center = false,
}) => {
  // Map component types to theme utility types
  const getSemanticType = (statusType: StatusType) => {
    switch (statusType) {
      case 'danger':
        return 'error';
      case 'default':
        return 'neutral';
      default:
        return statusType;
    }
  };

  const semanticType = getSemanticType(type);
  const statusStyles = semanticType === 'neutral'
    ? { bg: 'bg-neutral-50', text: 'text-neutral-600' }
    : getStatusColor(semanticType as 'success' | 'warning' | 'error' | 'info');

  return (
    <span
      className={classNames(
        'inline-flex px-[10px] py-[2px] text-sm font-medium rounded-3xl',
        statusStyles.bg,
        statusStyles.text,
        center && 'justify-center items-center',
        className,
      )}
    >
      {children}
    </span>
  );
};

export default TextStatus;
